<div class="banner justify-content-center" role="banner">
  <h1 class="text-white ms-3">{{ 'predictor.banner.text' | translate }}</h1>
</div>
<fgb-games-nav routeLink="predictor"></fgb-games-nav>

<div class="container">
  <div class="page-back-button-section" [routerLink]="['/games']">
    <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
  </div>
</div>
<router-outlet></router-outlet>
